
export default {
  name: 'ProductListingResultTopBar',

  props: {
    compactDisplayMode: {
      type: Boolean,
      required: true,
    },

    resultMessage: {
      type: String,
      required: true,
      default: '',
    },

    assumptionTooltipHtml: {
      type: String,
      required: true,
      default: '',
    },
  },

  methods: {
    toggleDetailDisplayMode() {
      this.$emit('toggle-detail-display-mode');
    },

    toggleCompactDisplayMode() {
      this.$emit('toggle-compact-display-mode');
    },
  },
};
